<div class="content pr-4">
    <div class="content-header">
        <div class="card p-d-flex p-jc-between p-mb-2">
            <div class="title">
                <h1>Operación del GNA para la selección aleatoria</h1>
                <p>Seleccione la fecha y el código de sorteo para generar su presorteo</p>
            </div>
            <div class="image">
                
            </div>
        </div>
    </div>
    <div class="content-body">
        <div class="card">
            <form [formGroup]="form">
                <div class="holder p-grid">
                    <div class="wrapper-input p-mb-3 p-col-3">
                        <div class="label-input">
                            <h5 style="display:inline;">Fecha</h5>
                            <h5 style="display:inline; color: red;" *ngIf="form.get('dateGameLottery').errors?.['required']">(*) </h5>
                        </div>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="pi pi-star"></i></span>
                            <p-calendar formControlName="dateGameLottery" [showTime]="true" [showSeconds]="true" inputId="time"></p-calendar>
                        </div>
                    </div>
                    <div class="wrapper-input p-mb-3 p-col-3">
                        <div class="label-input">
                            <h5 style="display:inline;">Código de sorteo</h5>
                            <h5 style="display:inline; color: red;" *ngIf="form.get('codeLottery').errors?.['required']">(*) </h5>
                        </div>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="pi pi-star"></i></span>
                            <input type="text" pInputText placeholder="Código de sorteo" name="codeLottery" formControlName="codeLottery"/>
                        </div>
                    </div>
                    <div class="btnSend p-col-6 p-d-flex p-jc-start p-ai-center">
                        <button pButton pRipple type="button" label="Generar" class="p-button-raised p-mt-2"
                            (click)="generateSelec()" [disabled]="!valid" style="width: 25%; background-color: #dc6a25; border-color: #dc6a25; color: #fff;"></button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
